"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var getServerSnapshot = function () { return false; };
var useMediaQuery = function (query) {
    var subscribe = (0, react_1.useCallback)(function (onStoreChange) {
        var mediaQuery = window.matchMedia(query);
        mediaQuery.addEventListener('change', onStoreChange);
        return function () {
            mediaQuery.removeEventListener('change', onStoreChange);
        };
    }, [query]);
    var getSnapshot = (0, react_1.useCallback)(function () { return window.matchMedia(query).matches; }, [query]);
    return (0, react_1.useSyncExternalStore)(subscribe, getSnapshot, getServerSnapshot);
};
exports.default = useMediaQuery;
